import React from "react";
import { useObserver } from "mobx-react-lite";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { grey, green } from "@material-ui/core/colors";
import { CheckCircle as CheckCircleIcon } from "@material-ui/icons";
import { Dialog, Table } from "components";
import Form from "./Form";
import { StoreProvider, useStore } from "./Store";
import { FormStoreProvider, useFormStore } from "./FormStore";

const useStyles = makeStyles({
  status: {
    color: green[500],
    width: "18px",
    height: "18px",
    "&.disabled": {
      color: grey[300],
    },
  },
});

export const Page = () => {
  const styles = useStyles();
  const store = useStore();
  const formStore = useFormStore();

  React.useEffect(() => {
    store.fetchUsers();
  }, [store]);

  const open = React.useCallback(() => formStore.modal(true), [formStore]);
  const close = React.useCallback(() => formStore.modal(false), [formStore]);

  return useObserver(() => (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs="auto">
        <Typography variant="h6" color="textSecondary">
          ユーザー
        </Typography>
      </Grid>

      <Grid item xs="auto">
        <Dialog
          title="ユーザー"
          open={formStore.open}
          onOpen={open}
          onClose={close}
        >
          <Form />
        </Dialog>
      </Grid>

      <Grid item xs={12}>
        <Table
          title=""
          isLoading={store.loading}
          options={{
            exportFileName: "ユーザー",
          }}
          data={store.users}
          columns={[
            {
              title: "メールアドレス",
              field: "loginId",
            },
            {
              title: "ステータス",
              field: "isActive",
              type: "boolean",
              render: (user) => (
                <CheckCircleIcon
                  className={[
                    styles.status,
                    user.isActive ? "" : "disabled",
                  ].join(" ")}
                />
              ),
            },
            {
              title: "代理店",
              field: "agency.name",
            },
            {
              title: "開発者",
              field: "developer.name",
            },
          ]}
          actions={[
            {
              icon: "edit",
              tooltip: "編集",
              onClick: (_, user) =>
                !Array.isArray(user) &&
                formStore.modal(true, {
                  id: user.id,
                  loginId: user.loginId,
                  isActive: user.isActive,
                  agencyId: user.agency ? user.agency.id : undefined,
                  developerId: user.developer ? user.developer.id : undefined,
                }),
            },
          ]}
        />
      </Grid>
    </Grid>
  ));
};

export default () => (
  <StoreProvider>
    <FormStoreProvider>
      <Page />
    </FormStoreProvider>
  </StoreProvider>
);
